import { GET_TRIP_API, GET_TRIPS_API } from "../utils/api";

export const LOAD_TRIP_REQUEST = "@trips/LOAD_TRIP_REQUEST";
export const RESET_TRIP_REQUEST = "@trips/RESET_TRIP_REQUEST";
export type TRIP_REQUEST = typeof LOAD_TRIP_REQUEST;
export type RESET_REQUEST = typeof RESET_TRIP_REQUEST;

interface ITrip {
  success: boolean;
  data: any;
}

export interface LoadTrips {
  type: TRIP_REQUEST;
  payload: {
    trips: ITrip | null;
  };
}

export interface LoadTrip {
  type: TRIP_REQUEST;
  payload: ITrip | null;
}

export interface zeroTrip {
  type: RESET_REQUEST;
  payload: {
    trips: null;
  };
}
interface IFilters {
  page: number;
  limit: number;
}

export async function loadTrips(filters: IFilters): Promise<LoadTrips> {
  try {
    const response = await GET_TRIPS_API(filters);
    return {
      type: LOAD_TRIP_REQUEST,
      payload: {
        trips: {
          success: response.data.success,
          data: response.data,
        },
      },
    };
  } catch (error) {
    return {
      type: LOAD_TRIP_REQUEST,
      payload: {
        trips: Object(error),
      },
    };
  }
}

export async function loadTrip(id: string): Promise<LoadTrip> {
  try {
    const response = await GET_TRIP_API(id);
    return {
      type: LOAD_TRIP_REQUEST,
      payload: {
        success: response.data.success,
        data: response.data.trip,
      },
    };
  } catch (error) {
    return {
      type: LOAD_TRIP_REQUEST,
      payload: Object(error),
    };
  }
}

export function resetTrip(): zeroTrip {
  return {
    type: RESET_TRIP_REQUEST,
    payload: {
      trips: null,
    },
  };
}
